


































    import { Vue, Component, Provide, Watch, Prop } from 'vue-property-decorator';
    import Header from './component/header';
    import BackDrop from '../../component-dev/backdrop';
    import Dialog from '../../component-dev/dialog';
    import Redbag from './component/redbag';
    import Button from '../../component-dev/button';
    import { IS_ZXG, IS_MQQ } from '../../service/platform/environment';
    import qs from 'qs';
    import { activity } from '../../service/activity';
    import { get } from 'lodash-es';
    const url = require('url');
    import { makeStatReportParam } from '../../service/stat/Directive';
    import { stat } from '../../service/stat';
    function platformAdapter(str: any, isZxg: any) {
        if (isZxg) {
            return str
                .replace('微证券', '自选股')
                .replace(
                    '助力奖励为现金红包、腾讯视频超级影视VIP月卡及iPhoneXS Max，三项奖励随机产生。',
                    '助力奖励为现金红包与腾讯视频超级影视VIP月卡，两项奖励随机产生。'
                )
                .replace(
                    '助力好友越多，财气越多，奖励越大，抽中iPhone机会越大。',
                    '助力好友越多，财气越多，奖励越大。'
                );
        }
        return str;
    }
    // 加载判断(首页，和动画页)
    let unloadList = [
      require('./images/bg_label.png'),
      require('./images/bg_dot.png'),
      require('./images/bg.png'),
      require('./images/getreward_btn.png'),
      require('./images/redbag_hand_up.png'),
      require('./images/redbag_hand_down.png'),
      require('./images/thanks.png'),
      require('./images/share_qrcode_first.png'),
    ];
    // 社区banner地址https://wzq.gtimg.com/activity/img/newyear_banner.c2510928.png

    // 大吉大利按钮的跳转链接
    const links = {
        wzqIndex: 'https://wzq.tenpay.com/mp/v1/choose/list.shtml',
        wzqApply: 'https://wzq.tenpay.com/mp/v1/apply/no_account.shtml',
        zxgIndex: 'qqstock://zixuan',
        zxgZSApply: 'qqstock://tradefunc/hsopenaccount',
    };
    const subscribeTime = new Date('2019/02/11 00:00:00').getTime()/1000; 
    
	@Component({
      components: {
        Header,
        Redbag,
        Dialog,
      }
    })
    
    export default class Page extends Vue {
      rewardInfo!: any;
      isShowRedbag: boolean = false;
      isOpenRedbag: boolean = true;
      $dialog!: any;
      userInfo: any = {};
      activity_start_time: any;
      activity_end_time: any;
      load: Boolean = false;
      unloadList = unloadList;
      totalCount = unloadList.length; //10
      loadedCount = 0; //1
      progress = '-100%';
      nickname: string;
      headimgurl: string;
      unmount: any;
      activityDetail: any;
      isshowRedbag: boolean = false;
      rule_type: any;
      activity_state: any;
      zxg: any;


    get isZxg() {
        const query = qs.parse(location.search.substring(1));
        return IS_MQQ ||
            IS_ZXG ||
            this.$route.query.from === 'zxg' ||
            query.from === 'zxg' || query._from === 'zxg' || this.$route.query._from === 'zxg';
    }
  
      onProgress() {
        this.progress = (this.loadedCount / this.totalCount - 1) * 100 +'%';  // 进度条从[-100%,0]
      }
      loadImg() {
        if(this.unloadList.length > 0){
            let url =this. unloadList.pop();
            this.getImage(url, false).then(()=>{
              this.loadedCount++;
              this.onProgress();
              // setTimeout(() => {
              //   this.loadImg();
              // }, 10)
              this.loadImg();
            });
        }else{
            // this.onComplete()
          this.load = true;
        }
      }
      
      async mounted() {
        let self = this;
        // 进入首页，如果用户已领领取过，则直接跳转到领奖页getreward
        try {
            const { data } = await activity.beforeGetReward();
            self.rewardInfo = data;
            // 判断是否活动期内   是否有关注
            const { data: activityDetail, headers: headers } = await activity.getActivityInfo();
            // 判断是否在活动推广期内
            let curTime: number = new Date(headers.date).getTime();
            let startTime: number = activityDetail.activity_start_time * 1000,
                endTime: number = activityDetail.activity_end_time * 1000;
            if ((curTime > startTime && curTime < endTime) && activityDetail.activity_state == '5') {
                // 活动期内
                const { data: userInfo } = await activity.getUserInfo();
                this.userInfo = userInfo;
                localStorage.setItem('nickname', this.userInfo.nickname);
                localStorage.setItem('headimgurl', this.userInfo.headimgurl);
                
                // if (userInfo.subscribe === '0' && userInfo.subscribe_time < subscribeTime && !IS_ZXG) {
                //     this.showFocusDialog();
                // } else {
                //     if (self.rewardInfo.reward_value) {
                //       this.$router.replace('/getreward');
                //     } else {
                //       this.loadImg();
                //       this.init();
                //     }
                // }
              // 改成先判断有无参加过，再判断关注是否在2.11之前  by 白总20180214
              if (self.rewardInfo.reward_value) {
                this.$router.replace('/getreward');
              } else {
                if ((userInfo.subscribe === '0' && !IS_ZXG) || (userInfo.subscribe === '1' && userInfo.subscribe_time > subscribeTime && !IS_ZXG)) {
                  this.showFocusDialog();
                } else {
                  this.loadImg();
                  this.init();
                }
              }
            } else {
               this.showActStatusDialog();
            }
        } catch (e) {
            // const { data = {} } = e;
            // this.$dialog.alert({
            //     content: '系统繁忙，请稍后重试',
            //     confirmBtn: '确定',
            // });
        }
      }
      getImage(imageUrl: any, replaceurl: boolean = true): any {
        return new Promise((resolve) => {
            let parsedImageUrl = imageUrl;
            if (replaceurl) {
                if (!/^data/.test(imageUrl) && /^https?/.test(imageUrl)) {
                    parsedImageUrl = url.parse(imageUrl).path;
                }
            }

            const img = new Image();
            img.src = parsedImageUrl;
            img.onload = () => resolve(img);
        });
      }

      getReward() {
        let self = this;
        const currentPath = this.$route.path;
        if (IS_ZXG) {
            stat.sendClickStat(
                makeStatReportParam('19newyear.index.getreward.click.zxg', currentPath),
                currentPath,
            );
        } else {
            stat.sendClickStat(
                makeStatReportParam('19newyear.index.getreward.click', currentPath),
                currentPath,
            );
        }
        
        self.getActivityDetail();
      }
    
      showRedbag() {
        // 活动已结束 | 未关注 | 领红包
        // let self = this;
        // self.getActivityDetail();
        
        // self.beforegetReward();
        const Redbag1 = Redbag as any;
        const unmount = BackDrop.mount({
          source: 'page',
          target: 'root',
          applyFilterFor: '#root',
          content: (
              <Redbag1 isOpenRedbag = {this.isOpenRedbag} nativeOnClick={() => setTimeout(() => unmount(), 800)}></Redbag1>
          )
        }, this.$createElement);
        this.unmount = unmount;
      }
      
      /* 
      * 展示活动已结束弹窗
      */
      showActStatusDialog() {
        const DialogE = Dialog as any;
        let str = '关注腾讯微证券，后续更多精彩';
        
        const unmount = BackDrop.mount({
          source: 'page',
          target: 'root',
          applyFilterFor: '#root',
          content: (
            <transition>
              <div class="layout-column layout-align-center-center " visible={true} onClick={ () => {}} onHide={() => {}}>
                  <DialogE class="dialog-box">
                    <template slot="header">
                      <h3 class="header-content">活动已结束</h3>
                      <p class="dialog-tips tips-focus glyph-font-fs">{platformAdapter(str, this.isZxg)}</p>  
                      <div class="btn-lucky-red" onClick={ () => {this.jumpToOtherPage()}}></div>
                    </template>
                  </DialogE>
              </div>  
            </transition>
          )
        }, this.$createElement);
      }
      
      /**
       * 展示关注弹窗
       */ 
      showFocusDialog() {
        const DialogE  = Dialog as any;
        const unmount = BackDrop.mount({
          source: 'page',
          target: 'root',
          applyFilterFor: '#root',
          content: (
            <transition>
              <div class="layout-column layout-align-center-center" visible={true} onClick={ () => {}} onHide={() => {}}>
                <DialogE class="dialog-box">
                  <template slot="header">
                    <h3 class="header-content glyph-font-hyjk hide">参与方式</h3>
                    <div class="dialog-focus">
                    </div>  
                    <div class="dialog-tips tips-qr-longtouch glyph-font-fs">
                      <p>该活动仅限老用户参与，</p>
                      <p>感谢理解</p>
                    </div>
                    <div class="btn-lucky-red unfocus-dialog-btn" onClick={() => {this.jumpToWzqIndex()}}></div>
                  </template>
                </DialogE>
              </div>
            </transition>
          )
        }, this.$createElement);
      }

      /**
       * 获取活动信息（开始结束时间）
       */
      async getActivityDetail() {
        let self = this;
        try {
            const { data: activityDetail, headers: headers } = await activity.getActivityInfo();
            // 判断是否在活动推广期内
            let curTime: number = new Date(headers.date).getTime();
            let startTime: number = activityDetail.activity_start_time * 1000,
                endTime: number = activityDetail.activity_end_time * 1000;
            if ((curTime > startTime && curTime < endTime) && activityDetail.activity_state == '5') {
                // 活动期内
                const { data: userInfo } = await activity.getUserInfo();
                this.userInfo = userInfo;
                localStorage.setItem('nickname', this.userInfo.nickname);
                localStorage.setItem('headimgurl', this.userInfo.headimgurl);
                if ((userInfo.subscribe === '0' && !IS_ZXG) || (userInfo.subscribe === '1' && userInfo.subscribe_time > subscribeTime && !IS_ZXG)) {
                // if (userInfo.subscribe === '0' && !IS_ZXG) {
                    this.showFocusDialog();
                } else {
                    this.showRedbag();
                    setTimeout(() => {
                        self.$router.replace('/getreward');
                        self.unmount();
                    }, 1500);   //  redbag stay 1000ms, animation time 500ms
            }
        } else {
            // 活动过期
            this.showActStatusDialog();
          }
        } catch (e) {
          this.$dialog.alert({
            content: '系统繁忙，请稍后重试',
            confirmBtn: '确定',
          });
        }
      }
      
      async getUserInfo() {
        let self = this;
        try {
          this.userInfo = await activity.getUserInfo();
        } catch (e) {
          const { data = {} } = e;
          this.$dialog.alert({
            content: '系统繁忙，请稍后重试',
            confirmBtn: '确定',
          });
        }
      }

      async beforegetReward() {
        let self = this;
        try {
          const { data } = await activity.beforeGetReward();
          self.rewardInfo = data;
          return data;
        } catch (e) {
          const { data = {} } = e;
          this.$dialog.alert({
            content: '系统繁忙，请稍后重试',
            confirmBtn: '确定',
          });
        }
      }

        async jumpToOtherPage() {
            const currentPath = this.$route.path;
            if (IS_ZXG) {
                const { data } = await activity.beforeGetReward();
							
                stat.sendClickStat(
                    makeStatReportParam('19newyear.popup.finish.btnlucky.click.zxg', currentPath),
                    currentPath,
                );
                if (data.rule_type == 1) {
                    stat.sendClickStat(
                        makeStatReportParam('19newyear.index.btnlucky.choose.click.zxg', currentPath),
                        currentPath,
                    );
                    location.href = links.zxgIndex;
                } else {
                    stat.sendClickStat(
                        makeStatReportParam('19newyear.index.btnlucky.apply.click.zxg', currentPath),
                        currentPath,
                    );
                    location.href = links.zxgZSApply;
                }
            } else {
                const { data: userInfo } = await activity.getUserInfo();
                this.userInfo = userInfo;
                stat.sendClickStat(
                    makeStatReportParam('19newyear.popup.finish.btnlucky.click', currentPath),
                    currentPath,
                );
                if (this.userInfo.userstate == '0' || this.userInfo.userstate == '3') {
                    stat.sendClickStat(
                        makeStatReportParam('19newyear.index.btnlucky.choose.click', currentPath),
                        currentPath,
                    );
                  location.replace(links.wzqIndex);
                } else {
                    stat.sendClickStat(
                        makeStatReportParam('19newyear.index.btnlucky.choose.click', currentPath),
                        currentPath,
                    );
                  location.replace(links.wzqApply);
                }
            }
        }
      
      jumpToWzqIndex() {
        const currentPath = this.$route.path;
        if (!IS_ZXG) {
          stat.sendClickStat(
            makeStatReportParam('19newyear.wuzige.index.btnlucky.choose.click', currentPath),
            currentPath,
          );
          location.replace(links.wzqIndex);
        }
      }
        init() {
            // this.getActivityDetail();
        }
    }
